module.exports = __webpack_public_path__ + "static/teleco_21-cb72c1bbcbb6fed257aa4fc2e08bc76a.jpg";